"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FieldPreviewValueDate;

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _usePkpass2 = require("../../../../usePkpass");

var _types = require("../../../../../../../types");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var getTimeOptions = function getTimeOptions(style) {
  var opts = {};
  opts.hour = '2-digit';
  opts.minute = '2-digit';
  opts.hour12 = false;

  switch (style) {
    case _types.PkpassDateStyleTypes.PKDateStyleShort:
      break;

    case _types.PkpassDateStyleTypes.PKDateStyleMedium:
      opts.second = '2-digit';
      break;

    case _types.PkpassDateStyleTypes.PKDateStyleLong:
      opts.second = '2-digit';
      opts.timeZoneName = 'short';
      break;

    case _types.PkpassDateStyleTypes.PKDateStyleFull:
      opts.second = '2-digit';
      opts.timeZoneName = 'long';
      break;

    default:
      break;
  }

  return opts;
};

var getDateOptions = function getDateOptions(style) {
  var opts = {};
  opts.year = 'numeric';

  switch (style) {
    case _types.PkpassDateStyleTypes.PKDateStyleShort:
      opts.day = '2-digit';
      opts.month = '2-digit';
      break;

    case _types.PkpassDateStyleTypes.PKDateStyleMedium:
      opts.day = 'numeric';
      opts.month = 'short';
      break;

    case _types.PkpassDateStyleTypes.PKDateStyleLong:
      opts.day = 'numeric';
      opts.month = 'long';
      break;

    case _types.PkpassDateStyleTypes.PKDateStyleFull:
      opts.day = 'numeric';
      opts.month = 'long';
      opts.weekday = 'long';
      break;

    default:
      break;
  }

  return opts;
};

function FieldPreviewValueDate(props) {
  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      language = _usePkpass.language;

  var value = props.value,
      dateStyle = props.dateStyle,
      timeStyle = props.timeStyle;
  var isDate = dateStyle !== _types.PkpassDateStyleTypes.PKDateStyleNone;
  var isTime = timeStyle !== _types.PkpassDateStyleTypes.PKDateStyleNone;
  var content = /*#__PURE__*/React.createElement("span", null);

  if (isDate && !isTime) {
    content = /*#__PURE__*/React.createElement(_reactIntl.FormattedDate, _extends({
      value: new Date(value)
    }, getDateOptions(dateStyle)));
  }

  if (!isDate && isTime) {
    content = /*#__PURE__*/React.createElement(_reactIntl.FormattedTime, _extends({
      value: new Date(value)
    }, getTimeOptions(timeStyle)));
  }

  if (isDate && isTime) {
    content = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_reactIntl.FormattedDate, _extends({
      value: new Date(value)
    }, getDateOptions(dateStyle))), ' ', /*#__PURE__*/React.createElement(_reactIntl.FormattedTime, _extends({
      value: new Date(value)
    }, getTimeOptions(timeStyle))));
  }

  return /*#__PURE__*/React.createElement(_reactIntl.IntlProvider, {
    locale: language
  }, content);
}

FieldPreviewValueDate.propTypes = {
  value: _propTypes.default.string.isRequired
};
//# sourceMappingURL=FieldPreviewValueDate.js.map